import { apis, getApiUrl } from '@/apis/business/api-config.js'
import { HttpMethod, ContentType } from '@/common/constant'

interface Config {
    IsExtract: boolean,
    OwnerId: string,
    Subject: string,
    StorageType: string,
    Files: Array<File>,
}

function getConfigApiUpload (config : Config) {
  console.log('Config API')

  const urlUpload = getApiUrl(apis.FileAPI) + '/v1/files/upload'
  const urlExtract = getApiUrl(apis.FileAPI) + '/v1/files/extraction'
  const configs = {
    url: config.IsExtract ? urlExtract : urlUpload,
    method: HttpMethod.POST,
    data: getFormData(config),
    headers: {
      'Content-Type': ContentType.FormMultiPart
    }
  }

  return configs
}

/**
     * Lấy thông tin file ra
     * Mặc định là có thông tin file rồi nên ko cần check nữa
     */
function getFormData (config : Config) {
  const form = new FormData()
  form.append('storageType', config.StorageType)
  form.append('subject', config.Subject)
  form.append('ownerId', config.OwnerId)

  config.Files.forEach(file => {
    form.append(file.name, file)
  })

  return form
}

export default getConfigApiUpload
export { getFormData, Config }
